const AccountType = {
    POSTPAID: "POSTPAID",
    PREPAID: "PREPAID",
    FIXED_LINE: "FIXED_LINE"
}
export default AccountType